import React from 'react';
import ReactDOM from 'react-dom';
// import registerServiceWorker from './registerServiceWorker';
import App from './App';

// 为了解决放大缩小页面， rem 计算错误的问题，需要重新设置 window.designWidth
window.addEventListener('resize', function () {
    designWidth();
}, false);

// 设计图尺寸——2048
function designWidth() {
    if (window.innerWidth > 1900) {
        window.designWidth = 2700;
    } else if (window.innerWidth > 1600) {
        window.designWidth = 2500;
    } else if (window.innerHeight < 880) {
        window.designWidth = 2300;
    } else {
        window.designWidth = 2048;
    }
}

designWidth();
window.pcNeedSelfAdaption = true;
require('./lib/flexible');

const hash = window.location.hash;
if (hash.indexOf('#/review') > -1) {
    require.ensure(
        ['./route/Review'],
        function (require) {
            let Review = require('./route/Review').default;
            ReactDOM.render(<Review />, document.getElementById('root'));
        },
        'Review'
    );
}

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js